module.exports = __webpack_public_path__ + "static/media/20210411_172404_498_IMG_0557.15aed7a2.jpg";